"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestWorkspaceCreate = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const WORKSPACE_CREATE_MUTATION = (0, graphql_tag_1.default) `
  mutation WorkspaceCreateMutation(
    $organization: ID!
    $area: ID!
    $email: String!
    $name: String
    $customId: String
    $templateWsId: String
  ) {
    workspaceCreate(
      organization: $organization
      area: $area
      managerEmail: $email
      data: { name: $name, customId: $customId }
      templateWsId: $templateWsId
    ) {
      id
      name
    }
  }
`;
const requestWorkspaceCreate = async (variables) => {
    const { data, errors } = await (0, apollo_1.mutate)(WORKSPACE_CREATE_MUTATION, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspaceCreate;
};
exports.requestWorkspaceCreate = requestWorkspaceCreate;
// async function requestWorkspaceCreate(variables, token) {
//   const response = await fetchRequest({
//     variables,
//     query: WORKSPACE_CREATE_MUTATION,
//     token,
//   })
//   if (!response) return errorUtil.noResponse()
//   const { errors, data } = response
//   if (errors) {
//     return errorUtil.apiError('something went wrong', errors)
//   }
//   return data.workspaceCreate
// }
exports.default = exports.requestWorkspaceCreate;
